import firebase from 'firebase';
import 'firebase/firestore';
import firebseConfig from './firebaseConfig';

const firebaseApp = firebase.initializeApp(firebseConfig);

export default firebaseApp.firestore();
